// Copyright ©️ 2025 eVolve MEP, LLC

export const isNil = (o: unknown): o is undefined | null | typeof NaN =>
  o === null || o === undefined || Number.isNaN(o);
export const isNotNil = <T>(o: T | null | undefined): o is NonNullable<T> => !isNil(o);
